function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { CLASSNAMES, SELECTORS, markupTemplates, separatorTpl, placeholderTpl, groupLabelTpl, optionTpl } from './constants';
import { validateNodeType } from '../../global/js/util';
var defaults = {
  renderOption: null,
  renderSelected: null
};

function isFunc(func) {
  return typeof func === 'function';
}

function tryAndPass(cond, str) {
  if (!cond) {
    throw new Error(str);
  }

  return cond;
}

function htmlToElement(html) {
  var template = document.createElement('div');
  template.innerHTML = html.trim();
  return template.firstChild;
}

function wrap(el, wrapper) {
  var parsedWrapper = htmlToElement(wrapper);
  el.parentNode.insertBefore(parsedWrapper, el);
  parsedWrapper.appendChild(el);
}

function insertMarkup(_node, pos, string) {
  _node.insertAdjacentHTML(pos, string);
}

function emitEvent(target, event) {
  var instance = document.createEvent('HTMLEvents');
  instance.initEvent(event, true, true);
  target.dispatchEvent(instance);
}

function getClassName(cn) {
  return CLASSNAMES[cn] || cn;
}

function switchClassName(target, classname) {
  var _target$classList;

  var condition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var method = condition ? 'add' : 'remove';
  var args = Array.isArray(classname) ? classname.map(getClassName) : [getClassName(classname)];

  (_target$classList = target.classList)[method].apply(_target$classList, _toConsumableArray(args));
}

var Dropdown =
/*#__PURE__*/
function () {
  _createClass(Dropdown, [{
    key: "_options",
    get: function get() {
      return Array.from(this._inputElement.options);
    }
  }, {
    key: "_selectedIndex",
    get: function get() {
      return this._inputElement.selectedIndex;
    }
  }, {
    key: "_selectedOption",
    get: function get() {
      return this._options[this._selectedIndex];
    }
  }, {
    key: "_value",
    get: function get() {
      return this._inputElement.value;
    },
    set: function set(value) {
      var isNotEmpty = value && value !== '';
      this._inputElement.value = value;

      this._setSelectedLabel();

      switchClassName(this._root, 'HAS_VALUE', isNotEmpty);
      switchClassName(this._root, 'PLACEHOLDER_MODE', !isNotEmpty);
      emitEvent(this._inputElement, 'change');
    }
  }], [{
    key: "create",
    value: function create(element, options) {
      return this.instances.get(element) || new this(element, options);
    }
  }, {
    key: "createAll",
    value: function createAll() {
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          initSelector = _ref.initSelector,
          options = _objectWithoutProperties(_ref, ["initSelector"]);

      validateNodeType(target);
      var selects = Array.from(target.querySelectorAll(initSelector || SELECTORS.root));
      selects.forEach(function (select) {
        return Dropdown.create(select, options);
      });
    }
  }, {
    key: "cssClasses",
    get: function get() {
      return CLASSNAMES;
    }
  }, {
    key: "strings",
    get: function get() {
      return SELECTORS;
    }
  }]);

  function Dropdown(root, _options) {
    var _this = this;

    _classCallCheck(this, Dropdown);

    _defineProperty(this, "open", function () {
      switchClassName(_this._root, ['ACTIVE', 'OPEN'], true);
    });

    _defineProperty(this, "update", function (options) {
      if (options) {
        _this.settings = _objectSpread({}, defaults, options);
      }

      _this._removeEventListeners();

      _this._fillOptionsList();

      _this._bindEventListeners();

      _this._value = '';
    });

    _defineProperty(this, "clear", function () {
      _this._value = '';
    });

    _defineProperty(this, "onFocus", function (e) {
      switchClassName(_this._root, 'ACTIVE', e.type === 'focus');
    });

    _defineProperty(this, "onChange", function () {
      Array.from(_this._list.children).forEach(function (el, idx) {
        switchClassName(el, 'optionSelected', idx === _this._selectedIndex);
      });
      switchClassName(_this._root, 'OPEN', false);
      emitEvent(_this._root, 'focus');
    });

    _defineProperty(this, "onClick", function (e) {
      var isClickInside = _this._root === e.target || _this._root.contains(e.target);

      var isOptionClick = _this._list.contains(e.target);

      switchClassName(_this._root, 'OPEN', isClickInside && !isOptionClick);

      if (!isClickInside) {
        switchClassName(_this._root, 'ACTIVE', false);
        emitEvent(_this._root, 'blur');
      }
    });

    this.settings = _objectSpread({}, defaults, _options);
    this._root = root;

    var _el = tryAndPass(this._root.querySelector(SELECTORS.inputElement), "Select must have an input element with a class of ".concat(SELECTORS.inputElement));

    var id = tryAndPass(_el.getAttribute('id'), 'Input should have unique and valid ID');
    var wrapperClassName = CLASSNAMES.wrapper;

    if (!_el.parentElement.classList.contains(wrapperClassName)) {
      wrap(_el, "<div class=\"".concat(wrapperClassName, "\"></div>"));
    }

    this._id = id;
    this._inputElement = _el;

    this._renderMarkup();

    this._processLabel();

    this._setAriaProps();

    this._fillOptionsList();

    this._bindEventListeners();

    this._value = this._inputElement.value;
    this.constructor.instances.set(this._root, this);
  }

  _createClass(Dropdown, [{
    key: "_getEl",
    value: function _getEl(key, all) {
      if (all) {
        return Array.from(this._root.querySelectorAll(SELECTORS[key]));
      }

      return this._root.querySelector(SELECTORS[key]);
    }
  }, {
    key: "_cacheEl",
    value: function _cacheEl(elements) {
      var _this2 = this;

      elements.forEach(function (el) {
        _this2["_".concat(el)] = _this2._getEl(el);
      });
    }
  }, {
    key: "_renderMarkup",
    value: function _renderMarkup() {
      var _this3 = this;

      markupTemplates.forEach(function (template) {
        var _template = template({
          value: _this3._selectedOption.innerHTML,
          id: _this3._id
        }),
            tpl = _template.tpl,
            elements = _template.elements,
            position = _template.position;

        insertMarkup(_this3._inputElement, position, tpl);

        _this3._cacheEl(elements);
      });
    }
  }, {
    key: "_setAriaProps",
    value: function _setAriaProps() {
      var listId = this._list.getAttribute('id');

      switchClassName(this._root, 'REQUIRED', !!this._inputElement.required);

      if (this._label) {
        var labelId = this._label.getAttribute('id');

        this._list.setAttribute('aria-labelledby', labelId);

        this._root.setAttribute('aria-labelledby', labelId);

        this._inputElement.setAttribute('aria-labelledby', labelId);
      }

      this._root.setAttribute('role', 'combobox');

      this._root.setAttribute('aria-expanded', 'false');

      this._root.setAttribute('aria-haspopup', listId);

      this._inputElement.setAttribute('aria-controls', listId);

      this._inputElement.setAttribute('aria-activedescendant', "".concat(this._id, "-option-").concat(this._selectedIndex));
    }
  }, {
    key: "_setSelectedLabel",
    value: function _setSelectedLabel() {
      var renderSelected = this.settings.renderSelected;

      if (this._selectedOption > 0 || this._selectedOption === undefined || this._value === '') {
        this._selectedValue.innerHTML = '';
      } else {
        this._selectedValue.innerHTML = isFunc(renderSelected) ? renderSelected(this._selectedOption) : this._selectedOption.innerHTML;
      }
    }
  }, {
    key: "_processLabel",
    value: function _processLabel() {
      this._label = this._getEl('label');

      if (this._label) {
        var labelId = "".concat(this._id, "-label");

        this._label.setAttribute('for', this._id);

        this._label.setAttribute('id', labelId);
      }
    }
  }, {
    key: "_fillOptionsList",
    value: function _fillOptionsList() {
      var placeholder = '';
      var idx = 0;
      var renderOption = this.settings.renderOption;
      var _id = this._id,
          selectedIndex = this.selectedIndex;
      var optionsRenderer = isFunc(renderOption) && renderOption;

      function traverseOptions(options, disabled) {
        return options.map(function (option) {
          var result;

          if (option.tagName === 'OPTGROUP') {
            result = traverseOptions(Array.from(option.children), option.disabled);
            result.unshift(groupLabelTpl({
              label: option.getAttribute('label'),
              disabled: option.disabled
            }));
            result = result.join('');
          } else {
            if (option.dataset.raySeparator !== undefined) {
              result = separatorTpl;
            } else if (option.dataset.rayPlaceholder !== undefined) {
              placeholder = placeholderTpl;
              result = '';
            } else {
              result = optionTpl({
                label: optionsRenderer ? optionsRenderer(option) : option.innerHTML,
                id: _id,
                idx: idx,
                selected: selectedIndex === idx,
                disabled: disabled || option.disabled
              });
            }

            idx += 1;
          }

          return result;
        });
      }

      var optionsList = traverseOptions(Array.from(this._inputElement.children));
      optionsList.unshift(placeholder);
      this._list.innerHTML = optionsList.join('');
    }
  }, {
    key: "_bindEventListeners",
    value: function _bindEventListeners() {
      var _this4 = this;

      if (this._inputElement.disabled) return;
      window.addEventListener('click', this.onClick);

      this._body.addEventListener('focus', this.onFocus);

      this._body.addEventListener('blur', this.onFocus);

      this._inputElement.addEventListener('change', this.onChange);

      this._getEl('option', true).forEach(function (el) {
        el.addEventListener('click', _this4.onOptionClick(_this4));
      });
    }
  }, {
    key: "_removeEventListeners",
    value: function _removeEventListeners() {
      window.removeEventListener('click', this.onClick);

      this._body.removeEventListener('focus', this.onFocus);

      this._body.removeEventListener('blur', this.onFocus);

      this._inputElement.removeEventListener('change', this.onChange);
    }
  }, {
    key: "isRequired",
    value: function isRequired() {
      return this._inputElement.required;
    }
  }, {
    key: "value",
    value: function value() {
      return this._value;
    }
  }, {
    key: "set",
    value: function set(value) {
      this._value = value;
    }
  }, {
    key: "disable",
    value: function disable() {
      this._inputElement.setAttribute('disabled', 'true');

      switchClassName(this._root, 'DISABLED', true);

      this._removeEventListeners();
    }
  }, {
    key: "enable",
    value: function enable() {
      this._inputElement.removeAttribute('disabled');

      switchClassName(this._root, 'DISABLED', false);

      this._bindEventListeners();
    }
  }, {
    key: "onOptionClick",
    value: function onOptionClick(plugin) {
      return function onClickListener() {
        if (!this.hasAttribute('disabled') && this.dataset.rayIdx) {
          plugin._value = plugin._options[this.dataset.rayIdx].value; //eslint-disable-line
        }
      };
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._removeEventListeners();

      this._body.remove();

      this._container.remove();

      this.constructor.instances.delete(this._root);
    }
  }]);

  return Dropdown;
}();

_defineProperty(Dropdown, "instances", new WeakMap());

export default Dropdown;